const mutations = {
  clearAuth: state => {
    state.user = {
      id: null,
      firstName: null,
      lastName: null
    }
    state.authStatus = {
      loggingIn: false,
      accessToken: null,
      refreshToken: null,
      authError: false,
      errorMessage: null
    }
  },
  clearAuthError: state => {
    state.authStatus.authError = false
    state.authStatus.errorMessage = null
  },
  setAccessToken: (state, token) => {
    state.authStatus.accessToken = token
  },
  setAuthError: (state, message) => {
    state.authStatus.authError = true
    state.authStatus.errorMessage = message
  },
  setAuthInfo: (state, authInfo) => {
    state.user = {
      id: authInfo.employeeId,
      firstName: authInfo.firstName,
      lastName: authInfo.lastName
    }
    state.authStatus = {
      accessToken: authInfo.accessToken,
      refreshToken: authInfo.refreshToken,
      authError: false,
      errorMessage: null
    }
  },
  setLoggingIn: (state, status) => {
    state.authStatus.loggingIn = status
  },
  setRefreshToken: (state, token) => {
    state.authStatus.refreshToken = token
  }
}

export default mutations
